export const transitions = {
  control: 'all 150ms ease-out',
};
